import { useContext } from "react";
import { useMutation, useQuery } from "react-query";
import AuthContext from "contexts/AuthContext";

const { REACT_APP_API } = process.env;

const createShipping = async ({ authTokens, payload }) => {
  const response = await fetch(`${REACT_APP_API}/shipping/create`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authTokens.accessToken}`,
    },
    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    throw new Error("Failed to create shipping");
  }

  return response.json();
};

export const useCreateShipping = (mutationOptions) => {
  const { authTokens } = useContext(AuthContext);

  return useMutation({
    mutationKey: ["createShipping"],
    mutationFn: (payload) => {
      // Use AuthContext tokens directly instead of localStorage to avoid stale tokens
      return createShipping({
        authTokens: { accessToken: authTokens?.access_token },
        payload,
      });
    },
    ...mutationOptions,
    enabled: !!authTokens,
  });
};

const retrieveLabelTracking = async ({ authTokens, payload }) => {
  const response = await fetch(
    `${REACT_APP_API}/shipping/retrieve-label-tracking`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${authTokens.access_token}`,
      },
      body: JSON.stringify(payload),
    }
  );

  if (!response.ok) {
    throw new Error("Failed to create shipping");
  }

  return response.json();
};

export const useRetrieveLabelTracking = ({ productId }, options = {}) => {
  const { authTokens } = useContext(AuthContext);

  return useQuery({
    queryKey: ["retrieveLabelTracking", productId],
    queryFn: () => {
      // Use AuthContext tokens directly instead of localStorage to avoid stale tokens
      return retrieveLabelTracking({
        authTokens: { access_token: authTokens?.access_token },
        payload: { productId },
      });
    },
    enabled: !!authTokens && !!productId,
    ...options,
  });
};

const generateShipping = async ({ authTokens, input }) => {
  const response = await fetch(`${REACT_APP_API}/shipping/generate-shipping`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authTokens.access_token}`,
    },
    body: JSON.stringify({ input }),
  });

  if (!response.ok) {
    throw new Error("Failed to generate shipping");
  }

  return response.json();
};

export const useGenerateShipping = (mutationOptions) => {
  const { authTokens } = useContext(AuthContext);

  return useMutation({
    mutationKey: ["generateShipping"],
    mutationFn: (input) => {
      // Use AuthContext tokens directly instead of localStorage to avoid stale tokens
      return generateShipping({
        authTokens: { access_token: authTokens?.access_token },
        input,
      });
    },
    ...mutationOptions,
    enabled: !!authTokens,
  });
};
